import {APPLY_FOR_HOST} from '../constants/actionTypes'; 


export const applyForHost = (payload)=>({
    type:APPLY_FOR_HOST,
    payload
})



